export default {

    gradients: [
        // ['#DA3732', '#8B3270', '#151237'],
        // ['#BE3445', '#8E316E', '#6D3289'],
        // ['#A43259', '#883173', '#70338B'],
        // ['#151237', '#8B3270', '#DA3732'],

        // ['#0055ff', '#500096', '#00c8ff'],
        // ['#500096', '#eb64ff', '#bedcff'],
        // ['#008c5f', '#ff7300', '#ffdc00'],
        // ['#ff3200', '#ff7300', '#5f2332'],

        ['#0096FF', '#8100C5', '#13052F'],
        ['#FF7400', '#BEDAFF', '#FFDA00'],
        ['#FF7400', '#FF3100', '#8100C5'],
        ['#BEDAFF', '#FF7400', '#630000'],
        ['#0096FF', '#00E156', '#13052F'],
    ]
}


// WEBPACK FOOTER //
// ./resources/assets/js/site/_site-config.js